module.exports = __webpack_public_path__ + "static/img/screenshot-1.a6fb863.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screenshot-1.png
// module id = vonW
// module chunks = 0